import { Pipe, PipeTransform } from '@angular/core';
import { resolvePersonName } from '../functions/person.function';
import { AvatarPerson } from '../models/avatar-person.model';

/** The full name of a person, from whichever field their reference carries it in; empty where none is known. */
@Pipe({
  name: 'personName',
})
export class PersonNamePipe implements PipeTransform {
  public transform(person: AvatarPerson | null | undefined): string {
    return resolvePersonName(person);
  }
}
